import {
  GET_ALL_COURSES,
  GET_BATCH_COURSES,
  GET_COURSE,
  GET_EMP_COURSES,
  GET_SCHOOL_COURSES,
  GET_SCHOOL_COURSES_WP,
  GET_SCHOOL_BATCH_COURSES,
} from 'actions/admin/courses';

const initialState = {
  courseData: {
    content: [],
  },
  schCourseData: {
    content: [],
  },
  courseList: [],
  batchCourseList: [],
  course: {},
  empCourseList: [],
  schoolBatchCourseList: [],
};

export default function courses(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_COURSES:
      return { ...state, courseData: action.courseData };
    case GET_SCHOOL_COURSES_WP:
      return { ...state, schCourseData: action.schCourseData };
    case GET_BATCH_COURSES:
      return { ...state, batchCourseList: action.batchCourses };
    case GET_COURSE: {
      return { ...state, course: action.course };
    }
    case GET_EMP_COURSES: {
      return { ...state, empCourseList: action.empCourses };
    }
    case GET_SCHOOL_COURSES: {
      return { ...state, courseList: action.courses };
    }
    case GET_SCHOOL_BATCH_COURSES: {
      return { ...state, schoolBatchCourseList: action.schoolBatchCourseList };
    }
    default:
      return state;
  }
}
